"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORGOT_PASSWORD_COPY = void 0;
exports.FORGOT_PASSWORD_COPY = {
    FORGOT_PASSWORD_HEADER: 'Forgot Password',
    FORGOT_PASSWORD_SUBTEXT: 'Please enter your email below, and we will send you instructions on how to reset your password.'
};
//# sourceMappingURL=COPY.js.map